import {
    getSelectedTableView,
    TableQueryType,
    TableView,
    GroupFolderTableQuery,
} from 'owa-mail-list-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getSelectedGroupId(): string {
    const tableView = getSelectedTableView();
    return getGroupId(tableView);
}

export function getGroupId(tableView: TableView): string {
    let groupId = null;

    if (tableView) {
        if (tableView.tableQuery.type === TableQueryType.Group) {
            groupId = tableView.tableQuery.folderId;
        } else if (
            isFeatureEnabled('grp-loadFolders') &&
            tableView.tableQuery.type === TableQueryType.GroupFolder
        ) {
            groupId = (tableView.tableQuery as GroupFolderTableQuery).groupId;
        }
    }

    return groupId;
}
